import { useState } from 'react';
import { Check, Undo2, X, Crosshair, Square, Circle, Hexagon, MoveDiagonal, Move } from 'lucide-react';
import { editArea } from '../lib/areaEdit';

const SHAPES = [['rect', Square], ['polygon', Hexagon], ['circle', Circle]];

export default function PitDrawBar({ t, net, pits }) {
  const d = net.draft;
  const [a, setA] = useState('');
  const [b, setB] = useState('');
  const setShape = (shape) => net.setDraft({ ...d, shape, points: [] });
  return (
    <div className="draw-bar pit-draw-bar" data-testid="pit-draw-bar">
      <div className="row pit-shapes">
        {SHAPES.map(([k, Icon]) => (
          <button key={k} className={`chip seg ${d.shape === k ? 'on' : ''}`} data-testid={`pit-shape-${k}`} onClick={() => setShape(k)}><Icon size={13} /> {t['pitShape_' + k]}</button>
        ))}
      </div>
      <p><span className="draw-count" data-testid="pit-point-count">{d.points.length} {t.drawPoints}</span> {t['pitHint_' + d.shape]}</p>
      <div className="row">
        <button className="btn btn-primary" data-testid="pit-crosshair-btn" onClick={net.addAtCrosshair}><Crosshair size={16} /> {t.btnCrosshair}</button>
        {d.shape === 'polygon' && <button className="btn btn-green" data-testid="pit-finish-btn" disabled={d.points.length < 3} onClick={pits.finish}><Check size={16} /> {t.btnFinish}</button>}
        {d.shape === 'polygon' && d.points.length >= 2 && <button className="btn btn-outline" data-testid="pit-draft-move-btn" onClick={() => editArea({ pts: d.points, label: t.aeTitle, onSave: (pts) => net.draftRef.current && net.setDraft({ ...net.draftRef.current, points: pts }) })}><Move size={16} /> {t.aeBtn}</button>}
        <button className="btn btn-outline" data-testid="pit-undo-btn" disabled={!d.points.length} onClick={() => net.setDraft({ ...d, points: d.points.slice(0, -1) })}><Undo2 size={16} /></button>
        <button className="btn btn-outline" data-testid="pit-cancel-btn" onClick={() => net.setDraft(null)}><X size={16} /> {t.btnCancel}</button>
      </div>
      {d.shape !== 'polygon' && (
        <div className="row pit-dims">
          <input type="text" inputMode="decimal" data-testid="pit-dim-a-input" placeholder={d.shape === 'circle' ? t.pitDia : t.pitLen} value={a} onChange={(e) => setA(e.target.value)} />
          {d.shape === 'rect' && <input type="text" inputMode="decimal" data-testid="pit-dim-b-input" placeholder={t.pitWid} value={b} onChange={(e) => setB(e.target.value)} />}
          <button className="btn btn-dark btn-sm" data-testid="pit-place-dims-btn" onClick={() => pits.fromDims(String(a).replace(',', '.'), String(b).replace(',', '.'))}><MoveDiagonal size={14} /> {t.pitPlace}</button>
        </div>
      )}
    </div>
  );
}
